import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {notifyUser} from '../api/notifyuser.api';
//import axios from 'axios';

interface usersState {
  users: string;
  loading: boolean;
  error: string;
  data: string;
}

// Define the initial state using that type
const initialState: usersState = {
  users: '',
  loading: false,
  error: '',
  data: '',
};

export const notifyCustomer = createAsyncThunk(
  'notify',
  async (parameters: any, thunkApi) => {
    return notifyUser(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const notifyCustomerSlice = createSlice({
  name: 'users',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(notifyCustomer.pending, state => {
      state.loading = true;
    });
    builder.addCase(notifyCustomer.fulfilled, (state, action) => {
      state.data = 'SUCCESS';
      state.loading = false;
      state.users = action.payload;
      console.log(state.data);
    });
    builder.addCase(notifyCustomer.rejected, (state, action) => {
      console.log('action====>', action);
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetState} = notifyCustomerSlice.actions;

export const notifyData = (state: RootState): string =>
  state.notifyReducer.users;
export const error = (state: RootState): string => state.notifyReducer.error;
export const loading = (state: RootState): boolean =>
  state.notifyReducer.loading;

export const notifyStatus = (state: RootState): string =>
  state.notifyReducer.data;

export default notifyCustomerSlice.reducer;
